import React, { useContext, useState } from "react";
import FlechaIzquierdaIcon from "../../../assets/images/generico/FlechaIzquierdaIcon";
import { PortalContext } from "../../../context/Provider";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import camelize from "../../../../global/utils/camelize";
import "./DatosTurnoKin.css";

const DatosTurnoKin = ({ pregunta, hora, fecha, medico, nTurno }) => {
  const { turnosDisponiblesState } = useContext(PortalContext);
  const [selected, setSelected] = useState(0);


  const handleClickMenu = () => {
    if (!selected && selected !== medico) {
      setSelected(medico);
    } else {
      setSelected(false);
    }
  };

  const itemSelected = selected === medico;

  return (
    <>
      <div className="ptur-datosKinesio-card">
        <div>
          <ul className="ptur-list-datosKinesio">
            <li
              className="ptur-option-datosKinesio rb14b"
              id={itemSelected ? "active" : ""}
              onClick={() => handleClickMenu()}
            >
              <div className="ptur-datosKinesio-tituloFlecha">
                <p className="ptur-datosTurnoKin-txtBox rb16xl">
                  <span style={{ marginRight: "15px" }}>
                    {nTurno + "."}
                  </span>
                  {getDiaStrTurno(fecha, false, true)}
                  {getDiaStrTurno(fecha, true, true)}
                </p>
                <div className="ptur-datosTurnoKin-box-bodyHora">
                  <span className="rb16t">{`${hora}hs`}</span>
                </div>
                {itemSelected ? (
                  <div className="ptur-datosKinesio-flechaCerrar">
                    <FlechaIzquierdaIcon />
                  </div>
                ) : (
                  <div className="ptur-datosKinesio-flechaAbrir">
                    <FlechaIzquierdaIcon />
                  </div>
                )}
              </div>
              <React.Fragment>
                <div className="ptur-datosKinesio-textoCard">
                  {itemSelected ? (
                    <div className="content">
                      <ul style={{ listStyle: "disc" }}>
                        <li>
                          <span className="rb14m">Especialista:</span>{" "}
                          <span className="rb14b">{camelize(medico)}</span>
                        </li>
                        <li>
                          <span className="rb14m">Tipo de Consulta:</span>
                          <span className="rb14b">Presencial</span>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </React.Fragment>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default DatosTurnoKin;
